import { connect } from 'dva';
import Finance from '../../../components/Finance/Finance';

const mapStateToProps = (state) => {
  return{
    informationList:state.finance.informationList,
    financingList:state.finance.financingList,
    projectList:state.finance.projectList
  };
};
const mapDispatchToProps = (dispatch) => ({
  // // 获取数据
  // getParkList:(region) =>{
  //   dispatch({type:'incubatormanage/getParkList',region:region});
  // },
  selectBlogList:()=>{
    dispatch({type:'finance/selectBlogList'});
  },
  selectProjectFiance:(region)=>{
    dispatch({type:'finance/selectProjectFiance',region});
  },
  selectGoldProject:(region)=>{
    dispatch({type:'finance/selectGoldProject',region});
  },
  getArgs:(region)=>{
    dispatch({type:'finance/getArgs',region});
  }
});

export default connect(mapStateToProps,mapDispatchToProps)(Finance);


// WEBPACK FOOTER //
// ./src/scripts/containers/Finance/Finance/index.js